<template>
  <div v-if="resourceData">
    <header-component position-relation></header-component>
    <div class="video-container">
      <div class="body-max-container-800">
        <h5 class="tag"># 影片</h5>
        <h1 class="title">{{ resourceData.title }}</h1>
        <div v-if="resourceData.haveResourceFile" class="video-download enter-btn" @click="handleDownloadResource">
          <img class="download-icon" src="../../assets/img/icon_download.svg" alt />
          <span>立刻下載</span>
        </div>
        <video-player
          ref="videoPlayer"
          class="video-player vjs-custom-skin"
          :playsinline="true"
          :options="playerOptions"
        />
        <ul>
          <li>
            <div class="home-content-info">
              <div class="home-content-info-body">
                <div class="title">影片簡介</div>
                <div class="subTitle">
                  {{ resourceData.resourceDesc }}
                </div>
              </div>
            </div>
          </li>
          <li v-if="resourceData.resourceGuideRead && resourceData.resourceGuideRead !== ''">
            <div class="home-content-info">
              <div class="home-content-info-body">
                <div class="title">影片導讀</div>
                <div class="subTitle">
                  {{ resourceData.resourceGuideRead }}
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="home-content-info">
              <div class="home-content-info-body">
                <div class="title">推薦觀看</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="swiperOptions" class="swiper" :class="{ 'body-max-container-800': !isMobile }">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="resource in getRecommendVideo" :key="`RecommendVideo_${resource.resourceId}`">
            <div class="recommend-video-box enter-btn" @click="goRecommendVideo(resource)">
              <img
                :src="getResourceUrl(resource.resourcePreview)"
                alt=""
                class="swiper-card"
              />
              <span>{{ resource.title }}</span>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../../components/HeaderComponent";
import FooterComponent from "../../components/FooterComponent";
import IndexMixin from "@/mixins/index-mixin";
import { DeviceTypeEnum } from "@/utils/enum";

export default {
  name: "Video",
  mixins: [IndexMixin],
  components: { FooterComponent, HeaderComponent },
  data() {
    return {
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-TW',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: '' // url地址
          }
        ],
        hls: true,
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: '影片出現問題，請稍後再試', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      swiperOptions: {
        // rewind: true,
        slidesPerView: 3,
        spaceBetween: 20,
        speed: 500,
        freeMode: true,
        loop: false,
        centeredSlides: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // bulletActiveClass: "paging-bullet-active",
          // bulletClass: "paging-bullet",
        },
      }
    };
  },
  created() {
    if (this.$store.getters.device === DeviceTypeEnum.MOBILE) {
      this.swiperOptions.slidesPerView = 1.5
      this.swiperOptions.loop = true
      this.swiperOptions.centeredSlides = true
    }
  },
  mounted() {
    this.setupData()
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player//自定义播放
    },
    /**
     * @returns {ResourceModel}
     */
    resourceData() {
      return this.$store.getters.resources.filter(x => x.resourceId === parseInt(this.$route.params.id))[0]
    },
    getRecommendVideo() {
      const videos = this.$store.getters.resources.filter(x => x.resourceType === 1 && x.resourceId !== parseInt(this.$route.params.id))
      return videos.sort(() => Math.random() - 0.5).slice(0, 3)
    },
    isMobile() {
      return this.$store.getters.device === DeviceTypeEnum.MOBILE
    }
  },
  watch: {
    '$route.params.id': function() {
      this.setupData()
    }
  },
  methods: {
    setupData() {
      this.playerOptions.sources[0].src = this.getResourceUrl(this.resourceData.resourceFile)
      this.playerOptions.poster = this.getResourceUrl(this.resourceData.resourcePreview)
    },
    /**
     * @param {ResourceModel} resource
     */
    goRecommendVideo(resource) {
      this.$router.push({
        name: "ResourceVideo",
        params: {
          id: resource.resourceId,
        },
      });
    },
    handleDownloadResource() {
      if (this.resourceData.downloadByMember === false || this.resourceData.downloadByMember && this.$store.getters.token) {
        this.goDownloadResource(this.resourceData.resourceFile)
      } else {
        this.$12nightsConfirm({
          title: "提示",
          message: "請先登入或註冊會員後，即可下載！"
        }).then(() => {
          this.$router.push({
            name: "Login"
          })
        })
      }
    }
  },
};
</script>

<style lang="scss">
.vjs-custom-skin > .video-js .vjs-big-play-button {
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  margin: auto !important;
  //margin-top: 0 !important;
}
</style>

<style lang="scss" scoped>
</style>
